import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryV1 } from './baseQueryV1';

export const employeePeriodsApi = createApi({
  reducerPath: 'employeePeriodsApi',
  baseQuery: baseQueryV1,
  tagTypes: ['EmployeePeriods'],
  endpoints: (builder) => ({
    getPeriodsByUserId: builder.query({
      query: (userId) => ({
        url: `employee-periods/user/${userId}`,
        method: 'GET',
      }),
      transformResponse: (res) => res.data,
      providesTags: ['EmployeePeriods'],
    }),
    getPeriodById: builder.query({
      query: (id) => ({
        url: `employee-periods/${id}`,
        method: 'GET',
      }),
      transformResponse: (res) => res.data,
      providesTags: ['EmployeePeriods'],
    }),
    addPeriod: builder.mutation({
      query: (period) => ({
        url: 'employee-periods',
        method: 'POST',
        body: period,
      }),
      transformResponse: (res) => res.data,
      invalidatesTags: ['EmployeePeriods'],
    }),
    updatePeriod: builder.mutation({
      query: ({ id, ...period }) => ({
        url: `employee-periods/${id}`,
        method: 'PUT',
        body: period,
      }),
      transformResponse: (res) => res.data,
      invalidatesTags: ['EmployeePeriods'],
    }),
    deletePeriod: builder.mutation({
      query: (id) => ({
        url: `employee-periods/${id}`,
        method: 'DELETE',
      }),
      transformResponse: (res) => res.data,
      invalidatesTags: ['EmployeePeriods'],
    }),
  }),
});

export const {
  useGetPeriodsByUserIdQuery,
  useGetPeriodByIdQuery,
  useAddPeriodMutation,
  useUpdatePeriodMutation,
  useDeletePeriodMutation,
} = employeePeriodsApi;
